import { colors, font, devices } from '../../config/theme'

import {
  textCenter,
  textRight,
  flexCenter,
  widthHeight100,
  width100,
  flexStart,
  flexCol,
  alignCenter,
  marginPadding0,
  hidden,
  pointer
} from '../../utils/jss-utils'

const style = {}

style.base = {
  ...textRight,
  minWidth: '300px',
  display: 'flex',
  // minHeight: '160px',
  fontSize: font.sizes.small
}

style.itemContainer = {
  ...textCenter,
  ...widthHeight100,
  ...flexStart,
  ...alignCenter,
  backgroundColor: colors.white,
  transition: 'all .25s',
  '& span': {
    transition: 'all .25s'
  },
  '&:hover': {
    cursor: 'pointer',
    '& span': {
      color: colors.white
    },
    backgroundColor: colors.black
  }
}
style.menu = {
  zIndex: '2424242',
  // height: '120px',
  border: `2px solid ${colors.black}`,
  ...marginPadding0,
  ...flexCol,
  ...flexCenter
}

style.content = {
  ...flexCol,
  ...width100,
  justifyContent: 'center'
}

style.item = {
  marginLeft: '20px',
  color: colors.black
}

style.iconContainer = {
  '& span': {
    transition: 'all .2s',
    opacity: '1',
    '&:hover': {
      cursor: 'pointer',
      opacity: '.8'
    }
  },
  '&> span:first-child': {
    marginRight: '55px'
  }
}

style.iconImg = {
  '& svg': {
    paddingLeft: '8px',
    width: '10px',
    height: '10px'
  },
  '& img': {
    paddingLeft: '8px',
    marginBottom: '4px',
    height: '15px',
    filter: 'invert(0.5)'
  }
}

style.hideOnMobile = {}
style.hideOnMobile[devices.mobile] = { ...hidden }
style.base[devices.mobile] = { ...hidden }

export default style
